import React from 'react';
import { Clickable } from 'src/components/clickable';
import { Lazy } from 'src/components/lazy';
import type { PrismicSliceImage } from 'src/types';
import * as S from './styles';

type Props = {
  className?: string;
} & Pick<PrismicSliceImage, 'image' | 'imageLinkOrPath'>;

const Image = ({ className, image, imageLinkOrPath }: Props) => {
  const isExternal = imageLinkOrPath?.startsWith('http');
  return image ? (
    <S.Image className={className}>
      <figure>
        <Lazy loadOnIdle>
          <Clickable
            to={imageLinkOrPath ?? ''}
            target={isExternal ? '_blank' : ''}
            isExternal={isExternal}
            disabled={!imageLinkOrPath}
          >
            <img src={image.url} alt={image.alt || ''} />
          </Clickable>
        </Lazy>
        {image.alt ? <figcaption>{image.alt}</figcaption> : null}
      </figure>
    </S.Image>
  ) : null;
};

export default Image;
